//import { forEach } from 'async';
import ee from 'event-emitter';

const emitter = ee();
const criteria = {};

export const cleanFilterCriteria = () => {
    Object.keys(criteria).forEach((key) => {
        if (!criteria[key] || !criteria[key].length) {
            delete criteria[key];
        }
    });
};

export const replaceFilterCriteria = (update = {}) => { 
    Object.keys(update).forEach((key) => {
        criteria[key] = update[key];
    });

    cleanFilterCriteria();

}

export const updateFilterCriteria = ({ update = {}, action = 'REPLACE' }) => {
    switch (action) {
        case 'REPLACE':
            Object.keys(update).forEach((key) => {
                criteria[key] = update[key];
            });
            break;
        case 'APPEND':
            Object.keys(update).forEach((key) => {
                criteria[key] = criteria[key] || [];

                if (criteria[key].indexOf(update[key]) === -1) {
                    criteria[key].push(update[key]);
                }
            });
            break;
        case 'REMOVE':
            Object.keys(update).forEach((key) => {
                if(criteria[key]){
                    const itemIndex = criteria[key].indexOf(update[key]);
                    if (itemIndex >= 0) {
                        criteria[key].splice(itemIndex, 1);
                    }
                }
            });
            break;
        default:
            break;
    }

    if(update && update.Releases) {
        
        $('#release-types .property-types__options input[type="checkbox"].all').prop('checked', false);

        if (update.Releases === "All") {
            var appending = (action == "APPEND");
            criteria.Releases = [];
            $('#release-types-title').text("No options selected");
            $('#release-types .property-types__options input[type="checkbox"]').each(i => {
                if (appending) {
                    criteria.Releases.push($('#release-types .property-types__options input[type="checkbox"]')[i].value);
                $('#release-types-title').text("Show All");
                }
            });
            $('#release-types .property-types__options input[type="checkbox"]').prop('checked', appending);
        }
        else {
            if (criteria.Releases.length > 1) {
                if (criteria.Releases.length == $('#release-types .property-types__options input[type="checkbox"]:not(.all)').length){
                    $('#release-types-title').text("Show All");
                    $('#release-types .property-types__options input[type="checkbox"].all').prop('checked', true);
                }else {
                    $('#release-types-title').text(criteria.Releases.length + " options selected");
                }
            }
            else if (criteria.Releases.length == 1) {
                $('#release-types-title').text($('#release-types .property-types__options input[type="checkbox"]:checked').siblings().text());
            }
            else {
                $('#release-types-title').text("No options selected");
            }

        }

        
    }
    cleanFilterCriteria();
};

export const getFilterCriteria = (fields) => {
    if (fields) {
        return fields.reduce((filteredCriteria, field) => ({ ...filteredCriteria, [field]: criteria[field] }), {});
    }
    return criteria;
};


export const filterProducts = (unfilteredData) => {
    let filteredData = unfilteredData;
    if (criteria.Area !== undefined && criteria.Area.length > 1) {
        filteredData = filteredData.filter(lot => lot.status.toLowerCase() == 'available');
        filteredData = filteredData.filter(lot => lot.lotSize >= criteria.Area[0] && lot.lotSize <= criteria.Area[1]);
    }
    if (criteria.Releases !== undefined){
        
        criteria.Releases = criteria.Releases.filter(c => c != "All")
        if (criteria.Releases.length){
            filteredData = filteredData.filter(lot => criteria.Releases.includes("" + lot.release.name))
        }
    }

    filteredData.forEach(lot => {
        if (criteria.Price !== undefined && criteria.Price.length > 1)
        {
            lot.products = lot.products.filter(product => product.price >= criteria.Price[0] && product.price <= criteria.Price[1]);
        }
        if (criteria.ProductTypes !== undefined && criteria.Price.length > 0) {
            lot.products = lot.products.filter(product =>criteria.ProductTypes.includes(product.type));
        }
        if (criteria.Carbays !== undefined) {
            lot.products = lot.products.filter(product => product.type == "Land" ||  product.garageSpaces == criteria.Carbays[0]);
        }
        if (criteria.Baths !== undefined) {
            lot.products = lot.products.filter(product => product.type == "Land" || product.bathrooms == criteria.Baths[0]);
        }
        if (criteria.Beds !== undefined) {
            lot.products = lot.products.filter(product => product.type == "Land" || product.bedrooms == criteria.Beds[0]);
        }
    });

    filteredData = filteredData.filter(lot => lot.products !== undefined && lot.products.length);

    return filteredData

}


export const filterCommunities = (unfilteredData) => {

    let filteredData = [];

    // Filter product types
    unfilteredData.forEach(community => {
        if (
            (!criteria.CommunityTypes || !criteria.CommunityTypes.length) ||
            (community.containsLand && criteria.CommunityTypes.includes('Land')) ||
            (community.containsHouseAndLand && criteria.CommunityTypes.includes('HouseAndLand')) ||
            (community.containsApartments && criteria.CommunityTypes.includes('Apartments')) ||
            (community.containsCompletedHomes && criteria.CommunityTypes.includes('CompletedHomes')) ||
            (community.containsTerraceHomes && criteria.CommunityTypes.includes('Terraces')) ||
            (community.containsTownhouses && criteria.CommunityTypes.includes('Townhouses')) ||
            (community.containsRetirementHomes && criteria.CommunityTypes.includes('Retirement Homes'))
        )
        {
            filteredData.push(community);
        }
    });
    
    // Filter status
    if (criteria.Status && criteria.Status !== "") {
        filteredData = filteredData.filter(community => community.projectStatus == criteria.Status);
    }    
    
    // Filter regions
    if (criteria.Region && criteria.Region !== "") {
        filteredData = filteredData.filter(community => community.region == criteria.Region);
    }    

    // Search (need to include description in filter)
    if ( criteria.Search ) {
        filteredData = filteredData.filter(community => 
            String(community.name).toLowerCase().includes(criteria.Search.toLowerCase()) || 
            String(community.description).toLowerCase().includes(criteria.Search.toLowerCase())
        )
    }

    return filteredData;
}

export default emitter;